import { render, staticRenderFns } from "./search-bid.vue?vue&type=template&id=905f52e0&scoped=true"
import script from "./search-bid.vue?vue&type=script&lang=js"
export * from "./search-bid.vue?vue&type=script&lang=js"
import style0 from "./search-bid.vue?vue&type=style&index=0&id=905f52e0&prod&lang=scss"
import style1 from "./search-bid.vue?vue&type=style&index=1&id=905f52e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905f52e0",
  null
  
)

export default component.exports